import { graphql } from 'relay-runtime';

export const UNIFIED_LEARNING_CERTIFICATES = graphql`
  query UnifiedLearningCertificationQuery(
    $username: String
    $after: String
    $first: Int
    $sortDirection: UnifiedSortDirection
    $sortField: UnifiedLearningCertificationSortField
    $status: UnifiedLearningCertificationStatus
    $type: [UnifiedLearningCertificationType!]
    $internalId: String
  ) {
    unified {
      unifiedProfile(
        unifiedProfileUsername: $username
        internalId: $internalId
      ) {
        ... on UnifiedProfile {
          id
          aaid
          learning {
            ... on UnifiedQueryError {
              identifier
              message
              extensions {
                statusCode
                errorType
              }
            }
            ... on UnifiedLearning {
              id
              certifications(
                first: $first
                after: $after
                status: $status
                type: $type
                sortField: $sortField
                sortDirection: $sortDirection
              ) {
                ... on UnifiedQueryError {
                  identifier
                  message
                  extensions {
                    statusCode
                    errorType
                  }
                }
                ... on UnifiedLearningCertificationConnection {
                  edges {
                    cursor
                    node {
                      id
                      activeDate
                      expireDate
                      imageUrl
                      name
                      nameAbbr
                      status
                      publicUrl
                    }
                  }
                  totalCount
                  pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                  }
                }
              }
            }
          }
        }
        ... on UnifiedQueryError {
          identifier
          message
          extensions {
            errorType
            statusCode
          }
        }
      }
    }
  }
`;
